/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListPackagesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListPackagesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListPackagesSecurity = {
  option1?: ListPackagesSecurityOption1 | undefined;
  option2?: ListPackagesSecurityOption2 | undefined;
};

export type ListPackagesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListPackagesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListPackagesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListPackagesSecurityOption1$Outbound,
  ListPackagesSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listPackagesSecurityOption1ToJSON(
  listPackagesSecurityOption1: ListPackagesSecurityOption1,
): string {
  return JSON.stringify(
    ListPackagesSecurityOption1$outboundSchema.parse(
      listPackagesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListPackagesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListPackagesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListPackagesSecurityOption2$Outbound,
  ListPackagesSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listPackagesSecurityOption2ToJSON(
  listPackagesSecurityOption2: ListPackagesSecurityOption2,
): string {
  return JSON.stringify(
    ListPackagesSecurityOption2$outboundSchema.parse(
      listPackagesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListPackagesSecurity$Outbound = {
  Option1?: ListPackagesSecurityOption1$Outbound | undefined;
  Option2?: ListPackagesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListPackagesSecurity$outboundSchema: z.ZodMiniType<
  ListPackagesSecurity$Outbound,
  ListPackagesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListPackagesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListPackagesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listPackagesSecurityToJSON(
  listPackagesSecurity: ListPackagesSecurity,
): string {
  return JSON.stringify(
    ListPackagesSecurity$outboundSchema.parse(listPackagesSecurity),
  );
}

/** @internal */
export type ListPackagesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListPackagesRequest$outboundSchema: z.ZodMiniType<
  ListPackagesRequest$Outbound,
  ListPackagesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listPackagesRequestToJSON(
  listPackagesRequest: ListPackagesRequest,
): string {
  return JSON.stringify(
    ListPackagesRequest$outboundSchema.parse(listPackagesRequest),
  );
}
